export const URLS: any = {
  BASE_MHO_API: process.env.REACT_APP_BASE_MHO_API_URL,
  MHO_API: `${process.env.REACT_APP_BASE_MHO_API_URL}/${process.env.REACT_APP_API_VERSION}${process.env.REACT_APP_API_ROOTPATH}`,
};
